// extracted by mini-css-extract-plugin
module.exports = {"container":"live_container__DSc7h","details":"live_details__MvTf_","description":"live_description__RAMpP","mobile":"live_mobile__MZzcw","desktop":"live_desktop__Ht6K7"};